import { providerLimitValues } from './provider-limit-values';
import { providerPreLimitValues } from './provider-pre-limit-values';
export var providerAvailablePreLimitOrLimitValues = function (merchantResponseData, provider) {
    var _a;
    if ((_a = merchantResponseData.data.limits) === null || _a === void 0 ? void 0 : _a.find(function (limit) { return limit.provider === provider; })) {
        return providerLimitValues(merchantResponseData, provider);
    }
    return providerPreLimitValues(merchantResponseData, provider);
};
